// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"0a19aa55","291":"8e37345c","397":"91db6830","491":"14ba0ebb","753":"a08848b0"}[chunkId] + ".chunk.js";
};